import React from 'react';
import { Helmet } from 'react-helmet-async';

function SEO({ 
  title = "8qn-download - MUST Exam Papers | Search, Preview & Download",
  description = "Find and download MUST (Meru University) exam papers from 2015-2026. Search by unit code, preview PDFs, and merge multiple papers. Covers all 7 schools.",
  keywords = "MUST exam papers, Meru University past papers, exam papers download, MUST SCI papers, MUST past exams, university exam papers Kenya",
  image = "/logo-with-bg.png",
  url = "https://8qn-download.pages.dev"
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
}

export default SEO;
